export default __webpack_public_path__ + "assets/pdf/carta-vino.3bf32f10.pdf";